import { SegmentEvents } from '@/constants/segment-events';
import { useSegmentEvent } from '@/hooks/useSegmentEvent';

export type ServiceType = 'sitting' | 'boarding' | 'walk' | 'drop-in';
export type ServiceCategory = 'overnight' | 'daytime';
export type BookingFlowType = 'marketplace' | 'direct-booking';

export interface StandardizedEventProperties {
  service_type: ServiceType;
  service_category: ServiceCategory;
  booking_flow_type: BookingFlowType;
  [key: string]: string | number | boolean;
}

/**
 * Tracks a standardized event with consistent properties
 * 
 * @param event The event name from SegmentEvents enum
 * @param properties The event properties including required service_type, service_category, and booking_flow_type
 */
export const trackStandardizedEvent = (
  trackEvent: ReturnType<typeof useSegmentEvent>['trackEvent'],
  event: SegmentEvents,
  properties: StandardizedEventProperties | { experiment_name: string, experiment_variant: string }
) => {
  trackEvent(event, properties);
};

/**
 * Helper function to determine the service category based on service type
 */
export const getServiceCategory = (serviceType: ServiceType): ServiceCategory => {
  switch (serviceType) {
  case 'sitting':
  case 'boarding':
    return 'overnight';
  case 'walk':
  case 'drop-in':
    return 'daytime';
  default:
    return 'daytime';
  }
};

/**
 * Helper function to determine if the booking flow is marketplace or direct-booking
 */
export const getBookingFlowType = (isMarketplace: boolean): BookingFlowType => {
  return isMarketplace ? 'marketplace' : 'direct-booking';
};
